import React from 'react'

import { Field } from 'redux-form'
import {
	FormSection,
	FieldHeader,
	FieldFooter,
	FieldInput,
	FieldSelect,
	FieldTextarea,
	FieldCheckbox,
	FieldWarningMsg
} from 'components/Form'

import { FieldIcon, FieldScopes } from './'

import {
	CHECKBOX,
	EMAIL,
	NAME,
	NUMBER,
	RADIO,
	SELECT,
	TEL,
	TEXT,
	TEXTAREA,
	HIDDEN,
	APP_ICON,
	APP_SCOPES,
	URL
} from './fieldTypes.js'

const renderInput = ({
	input,
	title,
	fieldId,
	placeholder,
	description,
	changeField,
	type,
	meta: { touched, error, dirty },
	customProps,
	options,
	autofocus,
	required,
	readOnly,
	highlighted,
	disabled,
	warningMsg,
	dark,
	hide
}) => {
	return !hide ? (
		<FormSection
			dirty={dirty}
			dark={dark}
			disabled={disabled}
			highlighted={highlighted}
		>
			{type !== CHECKBOX ? (
				<FieldHeader
					title={title}
					htmlFor={fieldId}
					isRequired={required}
					isReadOnly={readOnly}
					error={!!(touched && error)}
				/>
			) : (
				''
			)}
			{(type => {
				switch (type) {
					case TEXT:
					case EMAIL:
					case NAME:
					case NUMBER:
					case TEL:
					case URL:
						return (
							<FieldInput
								{...input}
								disabled={disabled || readOnly}
								readOnly={readOnly}
								name={fieldId}
								highlighted={highlighted}
								fieldId={fieldId}
								type={type}
								placeholder={placeholder}
								error={!!(touched && error)}
								autoFocus={autofocus}
							/>
						)
					case TEXTAREA:
						return (
							<FieldTextarea
								{...input}
								disabled={disabled}
								name={fieldId}
								fieldId={fieldId}
								placeholder={placeholder}
								error={!!(touched && error)}
								autoFocus={autofocus}
							/>
						)
					case HIDDEN:
						return (
							<FieldInput
								{...input}
								type={type}
								name={fieldId}
								fieldId={fieldId}
								error={!!(touched && error)}
							/>
						)
					case APP_ICON: {
						const { type, ...rest } = input // eslint-disable-line no-unused-vars
						return (
							<FieldIcon
								{...rest}
								customProps={customProps}
								disabled={disabled}
								changeField={changeField}
								type={'hidden'}
								name={fieldId}
								fieldId={fieldId}
								error={!!(touched && error)}
							/>
						)
					}
					case APP_SCOPES: {
						const { type, ...rest } = input // eslint-disable-line no-unused-vars
						return (
							<FieldScopes
								{...rest}
								disabled={disabled}
								changeField={changeField}
								name={fieldId}
								fieldId={fieldId}
								error={!!(touched && error)}
							/>
						)
					}
					case CHECKBOX:
						return (
							<FieldHeader
								title={title}
								htmlFor={fieldId}
								isRequired={required}
								error={!!(touched && error)}
								disabled={disabled}
								body={
									<FieldCheckbox
										{...input}
										disabled={disabled}
										name={fieldId}
										fieldId={fieldId}
										type={type}
										error={!!(touched && error)}
									/>
								}
							/>
						)
					case SELECT:
						return (
							<FieldSelect
								{...input}
								type={type}
								name={fieldId}
								fieldId={fieldId}
								options={options}
								error={!!(touched && error)}
							/>
						)
					case RADIO:
					default:
						return null
				}
			})(type)}

			{warningMsg ? (
				<FieldWarningMsg>{warningMsg}</FieldWarningMsg>
			) : null}
			<FieldFooter
				errorMessage={touched && error ? error : ''}
				description={description}
				disabled={disabled}
			/>
		</FormSection>
	) : null
}
renderInput.propTypes = {
	title: React.PropTypes.string,
	fieldId: React.PropTypes.string,
	placeholder: React.PropTypes.string,
	description: React.PropTypes.any,
	type: React.PropTypes.string,
	touched: React.PropTypes.bool,
	error: React.PropTypes.oneOf([React.PropTypes.bool, React.PropTypes.string])
}

const FieldSection = props => {
	return <Field {...props} component={renderInput} />
}

export default FieldSection



// WEBPACK FOOTER //
// ./src/containers/Forms/FieldSection.js